import { type FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import type { CouponRejectReasonSB } from '@mwl/core-lib';
import { setCouponOddsChangeV2 } from '@mwl/core-lib';
import ErrorIcon from '@public/assets/common/icons/alertError.svg';
import { Button } from '@/components/Button/Button';
import { useTypedDispatch } from '@/hooks';
import { errorMessageContent, possibleErrorCodes } from './CouponErrorMessage.data';
import type { CouponErrorMessageProps, PossibleErrorCodes, PossibleErrorsType } from './CouponErrorMessage.types';
import styles from './CouponErrorMessage.module.scss';
const CouponErrorMessage: FC<CouponErrorMessageProps> = ({
  coupon = {},
  closeToast,
  customErrorType
}) => {
  const dispatch = useTypedDispatch();
  const {
    t
  } = useTranslation('sport');
  const {
    rejectReasons
  } = coupon;
  const errorType = useMemo<PossibleErrorsType>(() => {
    if (customErrorType) {
      return customErrorType;
    }
    if (!rejectReasons) {
      return 'ANY';
    }
    const errorEntries = (Object.entries(possibleErrorCodes) as Entries<PossibleErrorCodes>);
    for (let i = 0; i < errorEntries.length; i += 1) {
      const [key, codes] = errorEntries[i];
      for (let j = 0; j < rejectReasons.length; j += 1) {
        if (codes.includes((rejectReasons as Array<CouponRejectReasonSB>)?.[j].code ?? '')) {
          return key;
        }
      }
    }
    return 'ANY';
  }, [customErrorType, rejectReasons]);

  // NOTE: на момент разработки кнопка выводится только в одном случае и делает только одно действие. В дальнейшем функционал можно привязать к коду ошибки
  const handleClick = useCallback(() => {
    dispatch(setCouponOddsChangeV2(true));
    closeToast();
  }, [closeToast, dispatch]);
  return <div className={styles.root} data-sentry-component="CouponErrorMessage" data-sentry-source-file="CouponErrorMessage.tsx">
      <div className={styles.header}>
        <ErrorIcon className={styles.icon} data-sentry-element="ErrorIcon" data-sentry-source-file="CouponErrorMessage.tsx" />
        <p className={styles.title}>{t('coupon.create_error.title_short', 'Error')}</p>
      </div>
      <p className={styles.text}>{t(errorMessageContent[errorType].content)}</p>
      {!!errorMessageContent[errorType].buttonText && <Button className={styles.button} as="button" fontWeight="bold" color="red" rounded cut={false} onClick={handleClick}>
          {t(errorMessageContent[errorType].buttonText ?? '')}
        </Button>}
    </div>;
};
export { CouponErrorMessage };